import { define, html, Component, store } from "hybrids";

import Broadcast, { Patron } from "~/stores/Broadcast";
import User from "~/stores/User";

export interface VBroadcastUser {
  user: User;
  patron?: Patron;
  connectedUsers: User[];
  connected: boolean;
  broadcast?: Broadcast;
  details: boolean;
  large: boolean;
  status: boolean;
  member: boolean;
}

export default define<VBroadcastUser>({
  tag: "v-broadcast-user",
  user: undefined,
  patron: (host, lastValue) =>
    lastValue || host.broadcast?.patrons.find((p) => p.user === host.user),
  connectedUsers: ({ broadcast }) => (broadcast ? broadcast.connected : []),
  connected: ({ connectedUsers, user }) => connectedUsers?.includes(user),
  broadcast: undefined,
  details: false,
  large: false,
  status: {
    get: (host, lastValue) =>
      lastValue ??
      ((host.broadcast?.users?.includes(host.user) ||
        host.broadcast?.course?.collaborators.includes(host.user)) && host.broadcast?.connected),
    set: (_, value) => value,
  },
  member: (host, lastValue) => lastValue || host.user.member,
  render: ({ user, patron, member, connected, details, status }) => html`
    <div
      id="avatar"
      title="${`${user.name}${
        status ? ` (${connected ? "online" : "offline"})` : ""
      }`}"
    >
      <v-ui-avatar class="${{ patron: member ? false : patron, member }}" src="${user.avatarThumbnail}"></v-ui-avatar>
      ${status && html`<div id="status" class="${{ connected }}"></div>`}
    </div>
    ${details &&
    html`<div id="name" class="${{ patron: member ? false : patron, member }}">${user.firstName}</div>`}
  `.css`
    :host {
      display: grid;
      grid-template-rows: min-content auto;
      row-gap: 6px;
    }
    
    v-ui-avatar.patron {
      --v-ui-avatar-border-width: 2px;
      --v-ui-avatar-border-color: var(--v-ui-color-patron);
    }
    
    v-ui-avatar.member {
      --v-ui-avatar-border-width: 2px;
      --v-ui-avatar-border-color: var(--v-ui-color-member);
    }

    #avatar {
      position: relative;
    }

    :host([large]) #avatar {
      width: 76px;
      --v-ui-avatar-size: 76px;
    }

    :host([large]) #avatar v-ui-avatar.patron {
      --v-ui-avatar-border-width: 4px;
    }

    #status {
      position: absolute;
      bottom: -2px;
      right: 0px;
      width: 20%;
      padding-top: 20%;
      border: 2px solid #252836;
      border-radius: 100%;
      background: #4B485A;
    }

    #status.connected {
      background: #64E067;
    }

    #name {
      font-size: 11px;
      text-align: center;
      text-transform: capitalize;
      color: var(--v-ui-color-text-secondary);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    #name.patron {
      color: var(--v-ui-color-patron);
    }

    #name.member {
      color: var(--v-ui-color-member);
    }
  `,
});
